import { Component } from '@angular/core';

/** Valores alineados con `src/app/library/colors/colors.scss` (referencia visual). */
@Component({
  selector: 'app-foundations-playground',
  templateUrl: './foundations-playground.component.html',
  styleUrls: ['./foundations-playground.component.scss'],
})
export class FoundationsPlaygroundComponent {
  readonly primaryBlues = [
    { token: '$blue_color_100', hex: '#1E5EA4' },
    { token: '$blue_color_90', hex: '#2367B3' },
    { token: '$blue_color_80', hex: '#2870C1' },
    { token: '$blue_color_70', hex: '#2E78D0' },
    { token: '$blue_color_60', hex: '#3381DE' },
    { token: '$blue_color_50', hex: '#388AED' },
    { token: '$blue_color_40', hex: '#66A5F1' },
    { token: '$blue_color_30', hex: '#95C1F6' },
    { token: '$blue_color_20', hex: '#C3DCFA' },
    { token: '$blue_color_10', hex: '#DCEEFF' },
  ];

  readonly greyLight = [
    { token: '$grey_color_100', hex: '#1E293B' },
    { token: '$grey_color_90', hex: '#2A3548' },
    { token: '$grey_color_80', hex: '#374357' },
    { token: '$grey_color_70', hex: '#465267' },
    { token: '$grey_color_60', hex: '#586479' },
    { token: '$grey_color_50', hex: '#6B778C' },
    { token: '$grey_color_40', hex: '#7F8BA1' },
    { token: '$grey_color_30', hex: '#94A2B7' },
    { token: '$grey_color_20', hex: '#CAD4E0' },
    { token: '$grey_color_10', hex: '#E2E8F1' },
  ];

  readonly statusGreen = [
    { token: '$green_status_color_100', hex: '#369752' },
    { token: '$green_status_color_50', hex: '#42CEA1' },
    { token: '$green_status_color_20', hex: '#BDEEDE' },
    { token: '$green_status_color_10', hex: '#D9F5EC' },
  ];

  readonly statusYellow = [
    { token: '$yellow_status_color_100', hex: '#BD6F12' },
    { token: '$yellow_status_color_50', hex: '#FCC97C' },
    { token: '$yellow_status_color_20', hex: '#FDDDAD' },
    { token: '$yellow_status_color_10', hex: '#FEE8C8' },
  ];

  readonly statusRed = [
    { token: '$red_status_color_100', hex: '#BB2A3E' },
    { token: '$red_status_color_50', hex: '#F9787F' },
    { token: '$red_status_color_20', hex: '#FFCED0' },
    { token: '$red_status_color_10', hex: '#FFF1F1' },
  ];

  readonly maia = [
    { token: '$maia-primary-color', hex: '#4754AC' },
    { token: '$maia-secondary-color', hex: '#0E20C2' },
    { token: '$maia-tertiary-color', hex: '#2879DB' },
  ];
}
